import { createContext, useContext } from 'react';
import { IUseWebAudioResult } from './useWebAudio';

const defaultVal: IUseWebAudioResult = {
  isPlay: false,
  play: async () => false,
  resume: () => {},
  suspend: () => {},
  close: () => {},

  addEventListener: () => {},
  removeEventListener: () => {},

  audioCtx: null
};

const webAudioContext = createContext<IUseWebAudioResult>(defaultVal);

const useGlobalWebAudioContext = () => useContext(webAudioContext);

export { useGlobalWebAudioContext };

export default webAudioContext;
